'use client';

import { Button } from '@ahafood/ui/components/button';
import { FormControl, FormField, FormItem } from '@ahafood/ui/components/form';
import { MinusIcon, PlusIcon } from 'lucide-react';
import type { Control } from 'react-hook-form';

interface QuantityControlProps {
  control: Control<any>;
  quantity: number;
  isMaxQuantity: boolean;
  onIncrease: () => void;
  onDecrease: () => void;
}

export function QuantityControl({
  control,
  quantity,
  isMaxQuantity,
  onIncrease,
  onDecrease,
}: QuantityControlProps) {
  return (
    <FormField
      control={control}
      name="quantity"
      render={() => (
        <FormItem className="flex flex-row items-center gap-2 flex-nowrap flex-none">
          <FormControl>
            <div className="flex flex-col">
              <div className="flex flex-row items-center">
                <Button
                  size="icon"
                  variant="secondary"
                  className="size-9 flex items-center justify-center"
                  onClick={onDecrease}
                  type="button"
                  aria-label="Giảm số lượng"
                  disabled={quantity <= 1}
                >
                  <MinusIcon className="size-4" />
                </Button>
                <div className="min-w-8 px-0.5 text-center font-semibold text-neutral-90">
                  {quantity}
                </div>
                <Button
                  size="icon"
                  variant="link"
                  className="size-9 flex items-center justify-center bg-primary-10 hover:no-underline"
                  onClick={onIncrease}
                  type="button"
                  aria-label="Tăng số lượng"
                >
                  <PlusIcon className="size-4" />
                </Button>
              </div>
              {isMaxQuantity && (
                <div className="text-xs text-red-50 mt-1">
                  Đã đạt số lượng tối đa
                </div>
              )}
            </div>
          </FormControl>
        </FormItem>
      )}
    />
  );
}
